export function calcRegionFilterMargin(depth: number) {
  return `${(depth - 1) * 8}px`;
}
